import type { Metadata } from "next";
import { NameAnalysisTool } from "@/components/name-analysis-tool";

export const metadata: Metadata = {
  title: "Tên Công Ty — Tử Vi Số",
  description: "Phân tích tên công ty theo phong thuỷ và Thần Số Học.",
};

type Props = { searchParams: Promise<{ name?: string; year?: string }> };

export default async function NamingCompanyPage({ searchParams }: Props) {
  const sp = await searchParams;
  return (
    <NameAnalysisTool
      searchParams={sp}
      title="Tên Công Ty"
      hint="Phân tích tên thương hiệu / công ty theo Mệnh và Thần Số Học."
      mode="company"
    />
  );
}
